<template>
    <v-form
        ref="formDeadlineDialog"
        v-model="form.valid"
        lazy-validation
    >
        <v-dialog v-model="dialogState" persistent max-width="740px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ $t('common.add') }}
                    <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                    </span>
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('contracts.form.deadlineDialog.title') }}</span>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0">
                            <v-text-field
                                v-model="setup.deadlines.item"
                                :label="$t('contracts.form.deadlineDialog.name.label')"
                                :rules="form.rules.deadlineName"
                                dense
                                filled
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" class="pt-0 pb-0">
                            <input-date-picker :setup.sync="form.deadlinePicker"></input-date-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="close()">{{ $t('common.close') }}</v-btn>
                    <v-btn color="primary" @click="save()">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import InputDatePicker from '@/components/InputDatePicker'

export default {
    name: 'contract-deadline-dialog',
    props: ['show', 'setup', 'contract'],
    components: {
        InputDatePicker
    },
    data () {
        return {
            dialogState: false,
            form: {
                valid: false,
                deadlinePicker: {
                    label: this.$t('contracts.form.deadlineDialog.deadline.label'),
                    rule: [
                        v => !!v || this.$t('contracts.form.deadlineDialog.deadline.required')
                    ],
                    checkDateisBeforeNow: true,
                    required: true,
                    readonly: false,
                    clearable: false,
                    filled: true,
                    dateFormatted: undefined
                },
                rules: {
                    deadlineName: [
                        v => !!v || this.$t('contracts.form.deadlineDialog.name.required'),
                        v => (v && v.length >= 3) || this.$t('contracts.form.deadlineDialog.name.length')
                    ]
                }
            }
        }
    },
    watch: {
        show: function (val, oldVal) {
            this.init()
            this.dialogState = val
        },
        dialogState: function (val, oldVal) {
            this.$emit('update:show', val)
        }
    },
    methods: {
        init () {
            this.$refs.formDeadlineDialog.reset()
        },
        save () {
            if (!this.$refs.formDeadlineDialog.validate()) {
                return
            }
            window.getApp.refreshContracts = true
            if (this.setup.deadlines.item) {
                this.contract.deadline.push({
                    isDone: false,
                    deadline: new Date(this.form.deadlinePicker.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString(),
                    name: this.setup.deadlines.item
                })
                this.setup.deadlines.item = undefined
            }
            this.close()
        },
        close () {
            this.$emit('close-deadline-dialog')
            this.dialogState = false
        }
    }
}
</script>
